import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=ed2796b6&scoped=true"
import script from "./LocationList.vue?vue&type=script&lang=ts"
export * from "./LocationList.vue?vue&type=script&lang=ts"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=ed2796b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2796b6",
  null
  
)

export default component.exports